import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Panveltomumbaiurbaniaonrent() {



  const cardData =
  {
    keyword: 'Panvel to Pune Cab',
    heading: 'Sai Trupti Cabs: Panvel to Pune Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Panvel to Pune cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Panvel, courteous service, and safe, smooth driving all the way to Pune. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Panvel to Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
  {
    "name": "Panvel to Pune Cab",
    "description": "Reliable cab service from Panvel to Pune offering comfortable rides with AC/non-AC options, professional drivers, luggage support, and flexible pickup/drop points. Ideal for family trips, corporate travel, and one-way or round trips, ensuring safe, timely, and convenient transportation with transparent fares."
  },
  {
    "name": "Panvel to Pune Taxi Service",
    "description": "Efficient taxi service from Panvel to Pune with well-maintained vehicles, AC/non-AC options, professional chauffeurs, luggage assistance, and flexible schedules. Perfect for daily commuters, business travelers, and leisure trips, providing a comfortable, safe, and hassle-free travel experience."
  },
  {
    "name": "Panvel to Pune Car Hire",
    "description": "Panvel to Pune car hire service with a variety of vehicles including Innova, Ertiga, and luxury options. Features include professional drivers, luggage support, AC/non-AC vehicles, and flexible pickup/drop schedules. Ideal for long-distance travel, family outings, and corporate trips with transparent fares."
  },
  {
    "name": "Panvel to Pune AC Cab",
    "description": "Comfortable AC cab service from Panvel to Pune with professional drivers, luggage assistance, and flexible pickup/drop options. Perfect for travelers seeking a cool, relaxing journey, suitable for corporate trips, family travel, and long-distance one-way or round trips."
  },
  {
    "name": "Panvel to Pune Non AC Cab",
    "description": "Economical non-AC cab service from Panvel to Pune offering professional drivers, luggage support, flexible pickup/drop points, and transparent pricing. Ideal for budget-conscious travelers seeking safe, comfortable, and reliable transportation without compromising convenience."
  },
  {
    "name": "Panvel to Pune Innova Cab",
    "description": "Spacious Innova cab service from Panvel to Pune with AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop schedules. Perfect for family trips, group travel, or corporate journeys, ensuring comfort, safety, and timely arrivals."
  },
  {
    "name": "Panvel to Pune Ertiga Cab",
    "description": "Panvel to Pune Ertiga cab rental with AC/non-AC options, professional drivers, luggage support, and flexible schedules. Ideal for small families, friends, or business travelers seeking comfortable, safe, and efficient transportation for one-way or round trips."
  },
  {
    "name": "Luxury Cab Panvel to Pune",
    "description": "Premium luxury cab service from Panvel to Pune with AC, top-class interiors, professional chauffeurs, luggage assistance, and timely pickups. Perfect for weddings, VIP travel, corporate trips, and special occasions, offering a stylish, comfortable, and secure journey with transparent fares."
  },
  {
    "name": "Affordable Panvel to Pune Cab",
    "description": "Budget-friendly cab service from Panvel to Pune with AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent pricing. Suitable for families, friends, and group travelers seeking reliable, safe, and cost-effective transportation."
  },
  {
    "name": "Panvel to Pune Outstation Cab",
    "description": "Outstation cab service from Panvel to Pune with AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop schedules. Perfect for long-distance travel, corporate trips, and family outings, offering comfortable, safe, and timely transportation with online booking options."
  },
  {
    "name": "Panvel to Pune One Way Cab",
    "description": "Convenient one-way cab service from Panvel to Pune with AC/non-AC options, professional drivers, luggage support, and transparent fares. Ideal for travelers needing a one-way drop, providing a hassle-free, safe, and comfortable journey with flexible scheduling."
  },
  {
    "name": "Panvel to Pune Drop Cab",
    "description": "Reliable drop cab service from Panvel to Pune with AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop points. Suitable for airport transfers, corporate trips, and personal travel, ensuring timely arrivals and safe, comfortable rides."
  },
  {
    "name": "Panvel to Pune Corporate Cab",
    "description": "Corporate cab service from Panvel to Pune providing AC/non-AC vehicles, professional chauffeurs, luggage support, and flexible pickup/drop schedules. Ideal for business trips, client visits, corporate events, and team travel, ensuring punctuality, professionalism, and safe transportation."
  },
  {
    "name": "Panvel to Pune Wedding Cab",
    "description": "Luxury and spacious cab service from Panvel to Pune for weddings with AC/non-AC options, professional drivers, luggage support, and timely pickups. Perfect for transporting family, guests, or VIPs, offering comfort, style, safety, and transparent fares for a seamless travel experience."
  },
  {
    "name": "Panvel to Pune Online Booking",
    "description": "Book your Panvel to Pune cab online instantly with secure payments, multiple AC/non-AC vehicle options, professional drivers, luggage support, and flexible pickup/drop points. Convenient for last-minute or planned travel, ensuring a safe, comfortable, and hassle-free journey with transparent fares."
  }
],
"tableData": [
  ["Panvel to Pune Cab", "Panvel to Pune Taxi Service"],
  ["Panvel to Pune Car Hire", "Panvel to Pune AC Cab"],
  ["Panvel to Pune Non AC Cab", "Panvel to Pune Innova Cab"],
  ["Panvel to Pune Ertiga Cab", "Luxury Cab Panvel to Pune"],
  ["Affordable Panvel to Pune Cab", "Panvel to Pune Outstation Cab"],
  ["Panvel to Pune One Way Cab", "Panvel to Pune Drop Cab"],
  ["Panvel to Pune Corporate Cab", "Panvel to Pune Wedding Cab"],
  ["Panvel to Pune Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Panvel to Pune Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Panvel to Pune — ideal for business trips, airport transfers, or leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Panvel to Pune trips, starting at affordable rates depending on vehicle type — no hidden charges or surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for the Panvel to Pune route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Panvel to Pune route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from any location in Panvel and drop-offs anywhere in Pune, including hotels, railway stations, airports, or city centers."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for your travel."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Panvel to Pune cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]




















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Panvel to Pune cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Panvel to Pune cab services for one-way trips, round trips, and group travel.',
  },
  {
    question: 'How can I book a Panvel to Pune cab with Sai Trupti Cabs?',
    answer: 'You can easily book a cab from Panvel to Pune through our website, mobile app, or by contacting our 24×7 customer support team for quick confirmation.',
  },
  {
    question: 'What types of cabs are available from Panvel to Pune?',
    answer: 'We offer a wide range of cabs including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury vehicles to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Panvel to Pune trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel on the Panvel–Pune route, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Panvel to Pune for corporate or personal travel?',
    answer: 'Certainly. Our cab services cater to corporate trips, family outings, airport transfers, and other personal travel between Panvel and Pune.',
  },
  {
    question: 'Is the Panvel to Pune cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Panvel to Pune for flexible travel plans and scheduling convenience.',
  },
  {
    question: 'What are the Panvel to Pune cab fares?',
    answer: 'Our cab fares from Panvel to Pune start from approximately ₹2,500–₹3,500 depending on the vehicle type, trip duration, and distance.',
  },
  {
    question: 'What payment methods are accepted for Panvel to Pune cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and bank transfers for secure and hassle-free payments.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Panvel to Pune cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety measures to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during Panvel to Pune cab trips?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Panvel to Pune cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Deshmukh',
    feedback: 'The Panvel to Pune cab I booked with Sai Trupti Cabs was excellent. The driver was punctual and the ride was very comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shreya Kulkarni',
    feedback: 'Sai Trupti Cabs made our trip from Panvel to Pune smooth and hassle-free. Highly recommended for safe and reliable service.',
    rating: 5,
  },
];

























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Panvel to Pune Cab",
  "image": "https://saitrupticabs.com/assets/images/panvel-to-pune-cab.jpg",
  "description": "Book a cab from Panvel to Pune with Sai Trupti Cabs. Choose from Innova, Ertiga, AC or Non-AC options, luxury and affordable rides for one-way trips, drop services, corporate travel, weddings, and outstation journeys. Online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/panvel-to-pune-cab"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Panvel to Pune Cab | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book a cab from Panvel to Pune with Sai Trupti Cabs. Choose from Innova, Ertiga, AC or Non-AC options, luxury and affordable rides for one-way trips, drop services, corporate travel, weddings, and outstation journeys. Online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Panvel to Pune Cab, Panvel to Pune Taxi Service, Panvel to Pune Car Hire, Panvel to Pune AC Cab, Panvel to Pune Non AC Cab, Panvel to Pune Innova Cab, Panvel to Pune Ertiga Cab, Luxury Cab Panvel to Pune, Affordable Panvel to Pune Cab, Panvel to Pune Outstation Cab, Panvel to Pune One Way Cab, Panvel to Pune Drop Cab, Panvel to Pune Corporate Cab, Panvel to Pune Wedding Cab, Panvel to Pune Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Panveltomumbaiurbaniaonrent;